import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { doPostFile } from "../../../config/fetchWrapper";
import { urls } from "../../endPoints";

export const ImportCorrectedFile = createAsyncThunk(
  "importCorrectedFile",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await doPostFile(urls?.importCorrectedFile, arg);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const ImportCorrectedFileSlice = createSlice({
  name: "importCorrectedFile",
  initialState: {
    isLoading: false,
    success: false,
    error: null,
    data: false,
  },
  reducers: {
    importCorrectedFileReset: () => {
      return {
        isLoading: false,
        success: false,
        error: null,
        data: false,
      };
    },
  },
  extraReducers: {
    [ImportCorrectedFile.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.success = true;
      state.data = payload;
      state.error = null;
    },
    [ImportCorrectedFile.pending]: (state) => {
      state.isLoading = true;
      state.data = false;
      state.error = null;
    },
    [ImportCorrectedFile.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
      state.success = false;
    },
  },
});

export const { importCorrectedFileReset } = ImportCorrectedFileSlice.actions;
